import { memo, useState } from 'react'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import moment from 'moment-timezone'
import { LAST_UPDATED_TEXT } from '../../../../utils/constants'
import './AlertCard.scss'
import editDots from '../../../../images/charts/editDots.png'
import { EditAlertPopup } from '../edit-alert-pop-up/EditAlertPopup'
import { parseUserDateTime } from '../../../../utils/common'

export const AlertCard = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    id,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    author = {},
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    description,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setDeleteAlertId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setEditAlertId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEditAllowed,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isFormOpened,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    deleteAlertCallback,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    className = '',
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    userTimeZone,
  }) => {
    const { Prefix, Suffix, FirstName, LastName, UserType } = author ?? {}

    const [isPopUpOpened, setIsPopUpOpened] = useState(false)

    // An alert can come back without an author (or with an author missing name parts), and this is
    // a clinical chart: build the title only out of the parts that are actually present, so a gap
    // in the payload drops the line rather than printing "undefined" at a clinician.
    const fullName = [Prefix, FirstName, LastName, Suffix].filter(Boolean).join(' ')
    const formattedUserType = UserType ? `${UserType.charAt(0).toUpperCase()}${UserType.slice(1)}` : ''
    const authorName = [fullName, formattedUserType].filter(Boolean).join(', ')

    const togglePopUpVisibility = () => {
      setIsPopUpOpened((prev) => !prev)
    }

    return (
      <div className={`alert-card-main-wrapper${className ? ` ${className}` : ''}`}>
        <div className='alert-card-header'>
          {authorName ?
            <div className='alert-card-text alert-card-title'>{authorName}</div>
          : null}
          {isEditAllowed && !isFormOpened ?
            <div className='alert-card-edit-tool-pop-up-container'>
              <img
                role='presentation'
                onClick={togglePopUpVisibility}
                className='alert-card-tools'
                id='dots'
                src={editDots}
                alt='editDots'
              />
              {isPopUpOpened ?
                <EditAlertPopup
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  alertId={id}
                  setIsPopUpOpened={setIsPopUpOpened}
                  setDeleteAlertId={setDeleteAlertId}
                  setEditAlertId={setEditAlertId}
                  editContainerId='Alerts-chart-section'
                />
              : null}
            </div>
          : null}
        </div>
        <div className='alert-card-text alert-card-date-time'>
          {LAST_UPDATED_TEXT}: {parseUserDateTime(dateTime, userTimeZone, true)}
        </div>
        <div className='alert-card-text alert-card-date-description'>{description}</div>
      </div>
    )
  },
)
